import { useParams } from 'react-router';

import type { AppRoute } from '#/routing/classes/AppRoute';
import type {
  AppRouteOptionalParams,
  AppRouteRequiredParams,
} from '#/routing/classes/types/AppRouteParams';

export function useAppRouteParams<T extends AppRoute<string, string, string>>(
  _routePath: T,
) {
  return useParams() as Record<AppRouteRequiredParams<T['fullPath']>, string> &
    Partial<Record<AppRouteOptionalParams<T['fullPath']>, string>>;
}
